// TimerProvider.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const TimerContext = createContext(false);
export const useCanWrite = () => useContext(TimerContext);

export function TimerProvider({ children }) {
  const [canWrite, setCanWrite] = useState(false);

  useEffect(() => {
    // calculate ms until next minute tick
    const now = Date.now();
    const untilNext = 60_000 - (now % 60_000);

    const scheduleWindow = () => {
      setCanWrite(true);
      setTimeout(() => setCanWrite(false), 1_000);  // 1 s window
    };

    // first window
    const firstTimeout = setTimeout(() => {
      scheduleWindow();
      // then every full minute
      const interval = setInterval(scheduleWindow, 60_000);
      return () => clearInterval(interval);
    }, untilNext);

    return () => clearTimeout(firstTimeout);
  }, []);

  return (
    <TimerContext.Provider value={canWrite}>
      {children}
    </TimerContext.Provider>
  );
}
